import styled from 'styled-components';

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
`;
